import PropTypes from 'prop-types';

// Utils
import { validateElementTypeEditPermission } from '../../../../../common/elements/utils/elementTypePermissionsUtils';

const RequireElementTypeEditPermission = ({ elementType, permissions, children }) => {
    if (!validateElementTypeEditPermission(permissions)(elementType)) return null;
    return children;
};

RequireElementTypeEditPermission.propTypes = {
    elementType: PropTypes.string,
    permissions: PropTypes.number,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

export default RequireElementTypeEditPermission;
